module.exports = __webpack_public_path__ + "img/p3.7779c68d.png";